import { Fragment } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    clearQuestionnaireMetaData,
    updateQuestionnaireConfig,
} from "src/redux/actions/questionnaireActions";
import { isValidLastPage } from "src/utils/helpers";
import {
    clearModalContent,
    setModalContent,
} from "src/redux/modules/modalEvent";
import { PauseOnboardingModal } from "src/containers/TherapistClientProfile";
import { cancelOnboarding } from "src/api/user";
import { faCirclePause } from "@fortawesome/free-regular-svg-icons";
import { Typography } from "src/latest/src/components";

type Props = {
    currentUser: any;
    handleNav: (path: string) => void;
};

export const OnboardingHeaderContent = ({ currentUser, handleNav }: Props) => {
    const dispatch = useDispatch();
    const { lastPageEdited } = useSelector(({ userIntake }: any) => userIntake);
    const { isAuthed, loggedInUser } = useSelector(
        (state: any) => state?.authentication
    );
    const { userRole, id } = loggedInUser;
    const headerContent = useSelector(
        (state: any) => state?.questionnaireData?.currentConfig?.header.content
    );
    const userId = useSelector(
        (state: any) => state?.questionnaireData?.initialMetadata?.user_id
    );
    const isPreonboardedUser = useSelector(
        (state: any) =>
            state?.questionnaireData?.initialMetadata?.is_preonboarded_user
    );
    const questionnaireType = useSelector(
        (state: any) =>
            state?.questionnaireData?.initialMetadata?.questionnaire_group?.type
    );
    const needHelpSelfMatchContactNumber = useSelector(
        (state: any) => state?.configuration?.needHelpSelfMatchContactNumber
    );

    const setSelectCategoryHeader = (categoryId: string) => {
        dispatch(updateQuestionnaireConfig(categoryId));
    };

    const openCancelOnboardingModal = () => {
        dispatch(
            setModalContent({
                modalContent: (
                    <PauseOnboardingModal
                        handleOnboardingStatus={onCancelOnboarding}
                        buttonLabel={"Cancel Onboarding"}
                    />
                ),
                title: (
                    <Typography color="color-28" variant="size-20">
                        Cancel Onboarding ?
                    </Typography>
                ),
                size: "sm",
                isGeneralPopup: true,
                backDrop: "static",
            })
        );
    };

    const onCancelOnboarding = async (note?: string) => {
        await cancelOnboarding(userId, note);
        dispatch(clearQuestionnaireMetaData());
        dispatch(clearModalContent());

        if (
            questionnaireType &&
            questionnaireType === "SELF_MATCHING_CLIENT_INTAKE"
        ) {
            handleNav("/therapy/clinician-availability");
        } else {
            handleNav("/therapy/scheduler");
        }
    };

    return (
        <Fragment>
            <Navbar.Toggle aria-controls="questionnaire-header">
                {[...Array(3)].map((_, i) => (
                    <span key={i} className="menu-stripped" />
                ))}
            </Navbar.Toggle>
            <Navbar.Collapse id="questionnaire-header">
                <Nav
                    className={`m${userRole?.toLowerCase() === "client" &&
                            isValidLastPage(lastPageEdited)
                            ? "x"
                            : "x"
                        }-auto`}
                >
                    {headerContent &&
                        headerContent.map((item: any, i: number) => {
                            return (
                                <Nav.Link
                                    key={i}
                                    href=""
                                    className={`${!id ? "d-none" : "d-block"} ${item.isSelected ? "active" : ""
                                        }`}
                                    onClick={() => {
                                        setSelectCategoryHeader(item.id);
                                    }}
                                >
                                    <div>
                                        <Typography
                                            color="color-29"
                                            variant="size-12"
                                            weight="semi-bold"
                                            className="text-uppercase"
                                        >
                                            {item.name}
                                        </Typography>
                                        <span />
                                    </div>
                                </Nav.Link>
                            );
                        })}
                </Nav>
                <div className="username-section">
                    {userId && id !== userId && currentUser ? (
                        (!currentUser?.full_name || !currentUser?.full_name?.trim()) ? (
                            <div>
                                <Typography
                                    color="color-35"
                                    weight="normal"
                                    variant="size-12"
                                    className="me-2 mb-1"
                                >
                                    <FontAwesomeIcon icon={faUser} /> Creating a
                                    profile for{" "}
                                </Typography>
                                <Typography
                                    color="color-2"
                                    weight="bold"
                                    variant="size-12"
                                >
                                    {currentUser?.email}
                                </Typography>
                            </div>
                        ) : (
                            <>
                                <div>
                                    <Typography
                                        color="color-35"
                                        weight="normal"
                                        variant="size-12"
                                        className="me-2 mb-1"
                                    >
                                        <FontAwesomeIcon icon={faUser} /> Creating a
                                        profile for{" "}
                                    </Typography>
                                </div>
                                <div>
                                    <Typography
                                        color="color-2"
                                        weight="bold"
                                        variant="size-12"
                                    >
                                        {currentUser?.full_name}
                                    </Typography>
                                </div>
                            </>
                        )
                    ) : (
                        ""
                    )}
                </div>

                {headerContent && (
                    <div className="intake-logout">
                        <Nav>
                            {questionnaireType &&
                                questionnaireType ===
                                "SELF_MATCHING_CLIENT_INTAKE" &&
                                !isAuthed && needHelpSelfMatchContactNumber && (
                                    <>
                                        <Typography
                                            color="color-28"
                                            weight="regular"
                                            variant="size-12"
                                            className="d-inline-block text-right"
                                        >
                                            Need help? Call us at
                                            <br />
                                            <Typography
                                                color="color-27"
                                                weight="extra-bold"
                                                variant="size-12"
                                                className="d-inline-block mt-2"
                                            >
                                                {needHelpSelfMatchContactNumber}
                                            </Typography>
                                        </Typography>
                                    </>
                                )}
                        </Nav>
                        <Nav>
                            {/* // TODO: show this when user is not client */}
                            {isAuthed && isPreonboardedUser && (
                                <>
                                    <Nav.Link
                                        onClick={() =>
                                            openCancelOnboardingModal()
                                        }
                                    >
                                        <Typography
                                            color="color-29"
                                            variant="size-12"
                                            weight="bold"
                                            className="text-uppercase intake-logout-text"
                                        >
                                            <FontAwesomeIcon
                                                className="me-2"
                                                icon={faCirclePause}
                                            />
                                            Cancel onboarding
                                        </Typography>
                                    </Nav.Link>
                                </>
                            )}
                        </Nav>
                        <Nav>
                            {id && (
                                <Nav.Link onClick={() => handleNav("/logout")}>
                                    <Typography
                                        color="color-29"
                                        variant="size-12"
                                        weight="bold"
                                        className="text-uppercase intake-logout-text"
                                    >
                                        Log Out
                                    </Typography>
                                </Nav.Link>
                            )}
                            {!id && (
                                <Nav.Link
                                    onClick={() => handleNav("/login")}
                                    className="text-center"
                                >
                                    <Typography
                                        color="color-27"
                                        variant="size-12"
                                        weight="bold"
                                        className="text-uppercase intake-logout-text"
                                    >
                                        Log In
                                    </Typography>
                                </Nav.Link>
                            )}
                        </Nav>
                    </div>
                )}
            </Navbar.Collapse>
        </Fragment>
    );
};
